import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ErrorBoundaryState {
  failed: boolean;
  reference: string;
}

export class ErrorBoundary extends Component<
  { children: ReactNode },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { failed: false, reference: '' };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true, reference: crypto.randomUUID().slice(0, 8) };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled Common Ground interface error', {
      name: error.name,
      componentStack: info.componentStack?.slice(0, 2000),
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="access-panel" aria-labelledby="unexpected-error-title">
        <p className="eyebrow">The table is safely preserved</p>
        <h1 id="unexpected-error-title" className="page-title">
          This view needs to reopen.
        </h1>
        <p role="alert">
          No unsaved command was reported as complete. Reload to restore the
          latest committed table state.
        </p>
        <p>
          Reference <code>{this.state.reference}</code>
        </p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload Common Ground
        </button>
      </main>
    );
  }
}
